export type Locale = {
  code: LocaleCodeType;
  label: string;
  rtl?: boolean;
  displayCode?: string;
};

export type LocaleCodeType = keyof typeof LocaleCode;

export const LocaleCode = {
  en: "en",
  fr: "fr",
  it: "it",
  es: "es",
  zh: "zh",
  "zh-TW": "zh-TW",
  pl: "pl",
  th: "th",
  tr: "tr",
  ar: "ar",
  vi: "vi",
  de: "de",
  id: "id",
  mn: "mn",
  "pt-BR": "pt-BR",
  "es-419": "es-419",
} as const;

export const defaultLocales: Readonly<
  Record<LocaleCodeType, Readonly<Locale>>
> = {
  [LocaleCode.en]: {
    code: LocaleCode.en,
    label: "English",
    displayCode: "EN",
  },
  [LocaleCode.ar]: {
    code: LocaleCode.ar,
    label: "العربية",
    rtl: true,
    displayCode: "AR",
  },
  [LocaleCode.zh]: {
    code: LocaleCode.zh,
    label: "中文",
    displayCode: "ZHS",
  },
  [LocaleCode["zh-TW"]]: {
    code: LocaleCode["zh-TW"],
    label: "繁体中文",
    displayCode: "ZHT",
  },
  [LocaleCode.th]: {
    code: LocaleCode.th,
    label: "ไทย",
    displayCode: "TH",
  },
  [LocaleCode.id]: {
    code: LocaleCode.id,
    label: "Bahasa Indonesia",
    displayCode: "ID",
  },
  [LocaleCode.it]: {
    code: LocaleCode.it,
    label: "Italiano",
    displayCode: "IT",
  },
  [LocaleCode.vi]: {
    code: LocaleCode.vi,
    label: "Tiếng Việt",
    displayCode: "VI",
  },
  [LocaleCode.es]: {
    code: LocaleCode.es,
    label: "Español",
    displayCode: "ES",
  },
  [LocaleCode.fr]: {
    code: LocaleCode.fr,
    label: "Français",
    displayCode: "FR",
  },
  [LocaleCode.de]: {
    code: LocaleCode.de,
    label: "Deutsch",
    displayCode: "DE",
  },
  [LocaleCode.pl]: {
    code: LocaleCode.pl,
    label: "Polski",
    displayCode: "PL",
  },
  [LocaleCode["es-419"]]: {
    code: LocaleCode["es-419"],
    label: "Español (LATAM)",
    displayCode: "LAS",
  },
  [LocaleCode.tr]: {
    code: LocaleCode.tr,
    label: "Türkçe",
    displayCode: "TR",
  },
  // While the _language_ is Brazilian Portuguese, we must display Portugal details for compliance.
  [LocaleCode["pt-BR"]]: {
    code: LocaleCode["pt-BR"],
    label: "Português",
    displayCode: "PT",
  },
  [LocaleCode.mn]: {
    code: LocaleCode.mn,
    label: "Монгол",
    displayCode: "MN",
  },
};
